(function ($) {
    jQuery(document).ready(function () {
        // Determine current season based on month
        function getCurrentSeason() {
            const month = new Date().getMonth() + 1; // getMonth() returns 0-11

            if (month >= 3 && month <= 5) {
                return 'spring';
            } else if (month >= 6 && month <= 9) {
                return 'summer';
            } else if (month >= 10 && month <= 11) {
                return 'fall';
            } else {
                return 'winter';
            }
        }

        // Add season class to body
        const season = getCurrentSeason();
        $('body').addClass('season-' + season);
    });
})(jQuery);
